import React, { Fragment, useCallback, useEffect, useState } from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Breadcrumbs, P } from "../../../AbstractElements";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { getAllRoles, updateRole } from "../../../store/slices/usersSlice";
import CreateRoleModal from "./createRoleModal";
import EditRoleModal from "./EditRoleModal";
import SweetAlert from "sweetalert2";
import { useDebounce } from "../../../Hooks/useDebounce";
const CustomersTable = () => {
  const history = useNavigate();
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [totalCount, setCount] = useState(0);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isModalEdit, setModalEdit] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);

  const [searchQuery, setSearchQuery] = useState("");
  const debouncedSearch = useDebounce(searchQuery, 300);
  const [sorting, setSorting] = useState([]);
  const [columnFilters, setColumnFilters] = useState([]);
  const columnFilterSearch = useDebounce(columnFilters, 300);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const rolesData = useSelector((state) => state.users.roles);

  const toggleEditModal = useCallback(() => {
    setModalEdit(!isModalEdit);
  }, [isModalEdit]);

  const openEditModal = (role) => {
    setSelectedRole(role);
    setModalEdit(true);
  };

  const fetchData = async (payload) => {
    const sortField = sorting.length > 0 ? sorting[0].id : undefined;
    const sortOrder =
      sorting.length > 0 ? (sorting[0].desc ? "desc" : "asc") : undefined;

    const response = await dispatch(
      getAllRoles({
        pagination: true,
        limit: pageSize,
        offset: page * pageSize,
        sortBy: sortField,
        sortOrder: sortOrder,
        ...payload,
      }),
    );

    if (response?.payload) {
      const resPayload = response.payload;
      let fetchedData = Array.isArray(resPayload)
        ? resPayload
        : resPayload.rolesData ||
          resPayload.roles ||
          resPayload.data ||
          resPayload.result ||
          resPayload.rows ||
          [];

      if (!Array.isArray(fetchedData)) fetchedData = [];

      setData(fetchedData);
      setCount(
        resPayload.count !== undefined
          ? resPayload.count
          : resPayload.total !== undefined
            ? resPayload.total
            : fetchedData.length,
      );
    }
  };

  useEffect(() => {
    fetchData({ searchQuery: debouncedSearch, filters: columnFilterSearch });
  }, [dispatch, page, pageSize, debouncedSearch, columnFilterSearch, sorting]);

  const columns = useMemo(
    () => [
      {
        accessorKey: "role_key",
        header: "Role Name",
        size: 150,
      },
      // {
      //   accessorKey: "description",
      //   header: "Descritption",
      //   size: 150,
      // },
      {
        accessorKey: "RolePermissions",
        header: "Permissions",
        size: 300,
        enableSorting: false,
        // Cell: ({ cell }) => cell.getValue().join(", "),
        Cell: ({ row }) => {
          const rolePermissions = row.original?.RolePermissions;
          console.log(rolePermissions, "rolePermissions");

          if (!Array.isArray(rolePermissions) || rolePermissions.length === 0) {
            return "—";
          }

          const permissionValues = rolePermissions
            .map((rp) => rp?.Permissions?.permission_value)
            .filter((val) => typeof val === "string");

          return permissionValues.length > 0
            ? permissionValues.join(", ")
            : "—";
        },
      },
      {
        accessorKey: "edit",
        header: "Edit",
        size: 100,
        enableSorting: false,
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <button
            className="btn btn-primary"
            onClick={() => openEditModal(row.original)}
          >
            Edit
          </button>
        ),
      },
    ],
    [],
  );

  const rowAction = (event, row) => {
    console.log(event, row);
  };

  const handlePageChange = (event) => {
    const newState =
      typeof event === "function"
        ? event({ pageIndex: page, pageSize: pageSize })
        : event;
    setPage(newState.pageIndex);
    setPageSize(newState.pageSize);
  };

  const handleOnChangeSearch = (value) => {
    setSearchQuery(value);
    setPage(0);
  };

  const table = useMaterialReactTable({
    columns,
    data,
    muiTableBodyRowProps: ({ row }) => ({
      onClick: (event) => rowAction(event, row),
      sx: {
        cursor: "pointer",
      },
    }),
    initialState: { density: "compact" },
    globalFilter: searchQuery,
    onGlobalFilterChange: handleOnChangeSearch,
    manualPagination: true,
    manualSorting: true,
    manualFiltering: true,
    rowCount: totalCount || 0,
    onPaginationChange: handlePageChange,
    onSortingChange: setSorting,
    onColumnFiltersChange: setColumnFilters,
    state: {
      pagination: { pageIndex: page, pageSize: pageSize },
      sorting,
      columnFilters,
      globalFilter: searchQuery,
    },
    renderTopToolbarCustomActions: ({ table }) => (
      <div
        sx={{
          display: "flex",
          gap: "16px",
          padding: "8px",
          flexWrap: "wrap",
        }}
      >
        <button className="btn bg-primary" onClick={() => setModalOpen(true)}>
          Create role
        </button>
      </div>
    ),
  });

  const toggle = useCallback(() => {
    setModalOpen(!isModalOpen);
    fetchData({ searchQuery: debouncedSearch, filters: columnFilterSearch });
  }, [isModalOpen, debouncedSearch, columnFilterSearch]);

  const saveUpdatedRole = async (updatedRole) => {
    console.log(updatedRole, "ON EDITTTT");

    try {
      const defaultPermissions = updatedRole?.permissions || [];
      const payload = { defaultPermissions };
      const resultAction = await dispatch(
        updateRole({ id: updatedRole?.ID, payload }),
      );
      if (updateRole.fulfilled.match(resultAction)) {
        fetchData({
          searchQuery: debouncedSearch,
          filters: columnFilterSearch,
        });
        await SweetAlert.fire({
          title: "",
          text: `Updated successfully!`,
          icon: "success",
          confirmButtonText: "Ok",
          reverseButtons: true,
        });
      } else {
        const errMsg =
          resultAction.payload ||
          resultAction.error?.message ||
          "Update failed";
        await SweetAlert.fire({ title: "Error", text: errMsg, icon: "error" });
      }
    } catch (err) {
      console.error("saveUpdatedRole error", err);
      await SweetAlert.fire({
        title: "Error",
        text: err.message || "Update failed",
        icon: "error",
      });
    }
    setModalEdit(false);
  };

  return (
    <Fragment>
      {isModalEdit && (
        <EditRoleModal
          isOpen={isModalEdit}
          toggle={toggleEditModal}
          role={selectedRole}
          onSave={saveUpdatedRole}
        />
      )}
      <CreateRoleModal isOpen={isModalOpen} toggle={toggle}></CreateRoleModal>
      <Breadcrumbs
        mainTitle="Manage Roles"
        parent="Roles"
        parentPath="roles"
        title="Roles List"
      />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <MaterialReactTable table={table} />
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default CustomersTable;
